function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("line", {
  x1: 18,
  y1: 6,
  x2: 6,
  y2: 18
});

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 6,
  y1: 6,
  x2: 18,
  y2: 18
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/clear.9de393af.svg";
export { SvgComponent as ReactComponent };